import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import {
    CORE_FEATURE_KEY,
    NOTIFICATION_STATE_KEY,
    REQUEST_LOADING_INDICATOR_STATE_KEY,
    SURVEYS_FEATURE_KEY,
} from '../constants/state-keys';
import { CoreCombinedReducersInterface } from '../interfaces/states/core-combined-reducers-states.interface';
import { notificationReducer, selectAll as selectNotifications } from './notification.reducer';

import { requestLoadingIndicatorReducer, selectIsBlockingRequestActive } from './request-loading-indicator.reducer';
import { selectAll as selectSurveys, surveysReducer } from './surveys.reducer';

export const coreReducers: ActionReducerMap<CoreCombinedReducersInterface> = {
    [NOTIFICATION_STATE_KEY]: notificationReducer,
    [REQUEST_LOADING_INDICATOR_STATE_KEY]: requestLoadingIndicatorReducer,
    [SURVEYS_FEATURE_KEY]: surveysReducer,
};

export const selectCoreFeature = createFeatureSelector<CoreCombinedReducersInterface>(CORE_FEATURE_KEY);

// notification
export const selectNotificationsState = createSelector(selectCoreFeature, (state) => state[NOTIFICATION_STATE_KEY]);
export const selectAllNotifications = createSelector(selectNotificationsState, selectNotifications);

// surveys
export const selectSurveysState = createSelector(selectCoreFeature, (state) => state[SURVEYS_FEATURE_KEY]);
export const selectAllSurveys = createSelector(selectSurveysState, selectSurveys);

// request loading indicator
export const selectRequestLoadingIndicatorState = createSelector(
    selectCoreFeature,
    (state) => state[REQUEST_LOADING_INDICATOR_STATE_KEY],
);

export const isBlockingRequestActive = createSelector(
    selectRequestLoadingIndicatorState,
    selectIsBlockingRequestActive,
);
